export default "__VITE_ASSET__CZlBmCCk__"